export const AT_MOVE_TO_SET = 'LIST_DETAILS_AT_MOVE_TO_SET';
export const AT_STATUS_SET = 'LIST_DETAILS_AT_STATUS_SET';
export const AT_RENAME_SET = 'LIST_DETAILS_AT_RENAME_SET';
